import React from 'react';

import classNames from 'classnames';

import { Box } from '../Box';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
import { Icon } from '../Icon';
import { useIsDesktop } from '../hooks';

import { SpacingParams } from './FilePreview.types';
import { useStyles } from './FilePreviewWrapper.styles';

const defaultSpasing: SpacingParams = {};

interface ErrorProps {
  withoutError?: boolean;
}

export const Error = ({ withoutError = false }: ErrorProps) => {
  const isDesktop = useIsDesktop();

  const { classes } = useStyles({
    mt: defaultSpasing,
    mb: defaultSpasing,
  });

  return (
    <Tooltip placement="top" title="Ошибка при загрузке файла">
      {!withoutError ? (
        <Box
          className={classNames('aqa_file_preview_error', classes.errorFile)}
        >
          <Box mb="4" fontSize={56} height={56}>
            <Icon name="vkhrtek_error_file" size="16" />
          </Box>
          <Box mb={{ xs: '0', md: '8' }}>
            <Typography
              display="block"
              variant="caption"
              color={
                isDesktop ? 'text.light.tertirary' : 'original.brand.primary'
              }
              align="center"
            >
              Ошибка при загрузке файла
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box height="100%" width="100%" />
      )}
    </Tooltip>
  );
};
